export class InsolesCustomerAccountSummaryModel {
    id: number;
    name: string;
}
